var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRobotTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34,
    fill: "url(#paint0_radial_21420_103965)",
    stroke: "#0E4C54",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47625 31.2251H11.4354V45.4289H9.47625C8.95675 45.4289 8.53467 45.0055 8.53467 44.4843V32.1697C8.53467 31.6485 8.95675 31.2251 9.47625 31.2251Z",
    fill: "url(#paint1_linear_21420_103965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80681 32.0532H8.53459V44.6014H7.80681C7.28732 44.6014 6.86523 44.178 6.86523 43.6568V32.9984C6.86523 32.4773 7.28732 32.0538 7.80681 32.0538V32.0532Z",
    fill: "url(#paint2_linear_21420_103965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.39 45.4292H61.4308V31.2254H63.39C63.9095 31.2254 64.3315 31.6488 64.3315 32.17V44.4846C64.3315 45.0058 63.9095 45.4292 63.39 45.4292Z",
    fill: "url(#paint3_linear_21420_103965)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0589 44.6011H64.3311V32.0529H65.0589C65.5784 32.0529 66.0005 32.4763 66.0005 32.9975V43.6559C66.0005 44.177 65.5784 44.6005 65.0589 44.6005V44.6011Z",
    fill: "url(#paint4_linear_21420_103965)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1442 16.7124H29.6714V18.3539H44.1442V16.7124Z",
    fill: "#58595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3069 30.288V41.9457C62.3069 46.1284 60.3435 49.8508 57.294 52.2439C55.1713 53.9069 52.5169 54.9234 49.6296 54.9966C49.5169 54.9996 49.4073 54.9996 49.2939 54.9996H23.328C23.2152 54.9996 23.1056 54.9996 22.9922 54.9966C20.0989 54.9234 17.4341 53.9002 15.3083 52.2273C12.2685 49.8379 10.3149 46.1185 10.3149 41.9457V30.288C10.3149 23.0791 12.3414 20.8698 20.0058 19.0033C26.1453 17.5069 33.0451 17.8535 36.3109 17.8535C39.5768 17.8535 47.1578 17.4368 52.6161 19.0033C59.7922 21.0597 62.3069 23.0791 62.3069 30.288Z",
    fill: "url(#paint5_linear_21420_103965)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2938 52.2441C55.1711 53.9071 52.5167 54.9236 49.6294 54.9967C49.5167 54.9998 49.4071 54.9998 49.2937 54.9998H23.3278C23.215 54.9998 23.1054 54.9998 22.992 54.9967C20.0987 54.9236 17.4339 53.9003 15.3081 52.2275C16.567 52.1808 33.0449 51.3843 36.3107 51.3843C39.5766 51.3843 56.0245 52.1943 57.2932 52.2441H57.2938Z",
    fill: "url(#paint6_linear_21420_103965)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3091 52.2275C16.568 52.1808 23.4862 51.3843 36.3117 51.3843C50.0494 51.3843 56.0254 52.1943 57.2941 52.2441",
    fill: "#11171E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5923 17.0989H29.2226C29.2226 13.8657 31.839 11.2402 35.0626 11.2402H38.7523C41.9752 11.2402 44.5923 13.865 44.5923 17.0989Z",
    fill: "url(#paint7_linear_21420_103965)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1179 43.0978C28.4744 43.0978 30.3847 41.2109 30.3847 38.8831C30.3847 36.5554 28.4744 34.6685 26.1179 34.6685C23.7614 34.6685 21.8511 36.5554 21.8511 38.8831C21.8511 41.2109 23.7614 43.0978 26.1179 43.0978Z",
    fill: "url(#paint8_linear_21420_103965)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1176 35.0756C23.9814 35.0756 22.2583 36.7849 22.2583 38.8829C22.2583 40.9809 23.9814 42.6901 26.1176 42.6901C28.2538 42.6901 29.977 40.9809 29.977 38.8829C29.977 36.7849 28.2538 35.0756 26.1176 35.0756ZM21.4434 38.8829C21.4434 36.3254 23.5408 34.2607 26.1176 34.2607C28.6944 34.2607 30.7919 36.3254 30.7919 38.8829C30.7919 41.4403 28.6944 43.505 26.1176 43.505C23.5408 43.505 21.4434 41.4403 21.4434 38.8829Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0831 40.2348C26.8274 40.2348 27.4308 39.6295 27.4308 38.8828C27.4308 38.1361 26.8274 37.5308 26.0831 37.5308C25.3388 37.5308 24.7354 38.1361 24.7354 38.8828C24.7354 39.6295 25.3388 40.2348 26.0831 40.2348Z",
    fill: "#0D828E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5342 36.3591H22.6987C23.4767 35.3316 24.7185 34.6672 26.1165 34.6672C27.5144 34.6672 28.7562 35.3316 29.5342 36.3591Z",
    fill: "#B4B5B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6532 35.9519H28.5811C27.9129 35.4042 27.0542 35.0749 26.1172 35.0749C25.1801 35.0749 24.3215 35.4042 23.6532 35.9519ZM22.3746 36.1134C23.2271 34.9874 24.5875 34.26 26.1172 34.26C27.6469 34.26 29.0072 34.9874 29.8598 36.1134L30.3545 36.7668H21.8799L22.3746 36.1134Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6989 43.0978C50.0554 43.0978 51.9658 41.2109 51.9658 38.8831C51.9658 36.5554 50.0554 34.6685 47.6989 34.6685C45.3424 34.6685 43.4321 36.5554 43.4321 38.8831C43.4321 41.2109 45.3424 43.0978 47.6989 43.0978Z",
    fill: "url(#paint9_linear_21420_103965)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6987 35.0756C45.5625 35.0756 43.8393 36.7849 43.8393 38.8829C43.8393 40.9809 45.5625 42.6901 47.6987 42.6901C49.8349 42.6901 51.558 40.9809 51.558 38.8829C51.558 36.7849 49.8349 35.0756 47.6987 35.0756ZM43.0244 38.8829C43.0244 36.3254 45.1219 34.2607 47.6987 34.2607C50.2755 34.2607 52.3729 36.3254 52.3729 38.8829C52.3729 41.4403 50.2755 43.505 47.6987 43.505C45.1219 43.505 43.0244 41.4403 43.0244 38.8829Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.734 40.2348C48.4783 40.2348 49.0817 39.6295 49.0817 38.8828C49.0817 38.1361 48.4783 37.5308 47.734 37.5308C46.9896 37.5308 46.3862 38.1361 46.3862 38.8828C46.3862 39.6295 46.9896 40.2348 47.734 40.2348Z",
    fill: "#0D828E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2798 36.3591H51.1153C50.3372 35.3316 49.0955 34.6672 47.6975 34.6672C46.2989 34.6672 45.0578 35.3316 44.2798 36.3591Z",
    fill: "#B4B5B5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9557 36.1134C44.8082 34.9875 46.1679 34.26 47.6982 34.26C49.2279 34.26 50.5883 34.9874 51.4408 36.1134L51.9355 36.7668H43.4609L43.9557 36.1134ZM45.2342 35.9519H50.1622C49.494 35.4042 48.6353 35.0749 47.6982 35.0749C46.7607 35.0749 45.9023 35.4042 45.2342 35.9519Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5361 46.1786C35.9547 46.1786 35.3562 46.1534 34.7577 46.1036C32.7257 45.9346 31.223 45.5309 31.2083 45.5266C31.2015 45.5247 31.1972 45.5179 31.1985 45.5106L31.2959 45.0779C31.2965 45.0742 31.2989 45.0712 31.302 45.0693C31.3038 45.0681 31.3063 45.0675 31.3087 45.0675C31.3099 45.0675 31.3112 45.0675 31.3124 45.0675C31.3357 45.0736 33.6728 45.7023 36.5673 45.7023C38.5332 45.7023 40.2742 45.4129 41.7408 44.8419C41.7427 44.8419 41.7439 44.8413 41.7457 44.8413C41.7476 44.8413 41.7494 44.8413 41.7512 44.8425C41.7543 44.8444 41.7574 44.8468 41.758 44.8505L41.8964 45.2703C41.8989 45.277 41.8952 45.2844 41.8884 45.2869C40.4825 45.8344 38.8291 46.1325 36.9741 46.1731C36.8295 46.1761 36.6819 46.178 36.5355 46.178L36.5361 46.1786Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.746 44.8549L41.8845 45.2747C40.2684 45.904 38.5201 46.1265 36.9751 46.1603C36.8274 46.1633 36.681 46.1652 36.537 46.1652C35.8926 46.1652 35.291 46.1344 34.7593 46.0902C32.715 45.92 31.227 45.5174 31.2123 45.5137L31.3097 45.0811C31.3464 45.0909 33.689 45.7165 36.5683 45.7165C38.2291 45.7165 40.0675 45.5088 41.7467 44.8549M41.7467 44.8279C41.7436 44.8279 41.7399 44.8279 41.7369 44.8297C40.2715 45.4 38.5329 45.6895 36.5683 45.6895C33.6762 45.6895 31.3403 45.0614 31.317 45.0553C31.3146 45.0547 31.3121 45.054 31.3103 45.054C31.3054 45.054 31.3005 45.0553 31.2968 45.0577C31.2907 45.0614 31.2864 45.0676 31.2845 45.0749L31.1871 45.5076C31.1841 45.5217 31.1927 45.5359 31.2061 45.5395C31.2208 45.5438 32.7217 45.9476 34.758 46.1172C35.3566 46.167 35.9557 46.1922 36.5377 46.1922C36.6841 46.1922 36.8317 46.1904 36.9763 46.1873C38.8331 46.1461 40.4878 45.8481 41.8949 45.2999C41.9084 45.2949 41.9151 45.2802 41.9108 45.2667L41.7724 44.8469C41.7699 44.8402 41.765 44.834 41.7583 44.831C41.7546 44.8291 41.751 44.8285 41.7467 44.8285V44.8279Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21420_103965",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 36) rotate(90) scale(36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21420_103965",
    x1: 8.90511,
    y1: 31.2251,
    x2: 11.0649,
    y2: 45.4289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21420_103965",
    x1: 7.47412,
    y1: 44.6014,
    x2: 7.9257,
    y2: 32.0532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21420_103965",
    x1: 62.2286,
    y1: 31.2254,
    x2: 63.5337,
    y2: 45.4292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21420_103965",
    x1: 64.7926,
    y1: 44.6011,
    x2: 65.539,
    y2: 32.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21420_103965",
    x1: 17.7127,
    y1: 17.8032,
    x2: 54.9091,
    y2: 54.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21420_103965",
    x1: 15.3081,
    y1: 51.6514,
    x2: 57.2938,
    y2: 54.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44647D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21420_103965",
    x1: 33.9781,
    y1: 11.2402,
    x2: 39.8368,
    y2: 17.0989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05656F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21420_103965",
    x1: 26.1179,
    y1: 34.6685,
    x2: 26.1179,
    y2: 43.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255760"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_21420_103965",
    x1: 47.6989,
    y1: 34.6685,
    x2: 47.6989,
    y2: 43.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255760"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobotTutorial);
export default __webpack_public_path__ + "static/media/icon-robot-tutorial.23d33660a2c0e5aa2fc189f7213a6ac0.svg";
export { ForwardRef as ReactComponent };